import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import {
    animateText,
    onSideNavChange,
    selectedItemMenu,
} from 'src/app/core/animations/animations-menu';
import { MenuService } from 'src/app/core/services/menu/menu.service';
import { AuthService } from '../../core/auth/auth.service';
import { Role } from '../../core/auth/roles';
import { IconName } from '../mb-icon/icon.type';

interface Page {
    link: string;
    name: string;
    icon?: IconName;
    iconSrc?: string;
    state: string;
    allowedRoles: Role[];
}

@Component({
    selector: 'app-left-menu',
    templateUrl: './left-menu.component.html',
    styleUrls: ['./left-menu.component.scss'],
    animations: [onSideNavChange, animateText, selectedItemMenu],
})
export class LeftMenuComponent {
    public sideNavState: boolean;
    public linkText: boolean;
    iconsMenu = [{ name: 'profile' }, { name: 'team' }];
    public pages: Page[] = [
        {
            name: 'Onboarding',
            link: 'onboarding',
            icon: 'assignment_ind' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
        {
            name: 'Desconto',
            link: 'desconto',
            icon: 'attach_money' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
        {
            name: 'Relatórios',
            link: 'reports',
            iconSrc: 'assets/img/excel.svg',
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
        {
            name: 'Feature Flags',
            link: 'feature-parameters',
            icon: 'toggle_on' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.CustodiaDev],
        },
        {
            name: 'Ciclo de Cobrança',
            link: 'ciclo-cobranca',
            icon: 'calendar_month' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
        {
            name: 'Retry Relatório',
            link: 'retry-relatorio',
            icon: 'replay' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.CustodiaDev],
        },
        {
            name: 'Reenvio Corrigido',
            link: 'reenvio-relatorio-corrigido',
            icon: 'email',
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.CustodiaDev],
        },
        {
            name: 'Disparar Cobrança',
            link: 'disparar-cobranca',
            icon: 'payments' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.CustodiaDev],
        },
        {
            name: 'Processar Cobrança',
            link: 'processamento-cobranca',
            icon: 'receipt_long' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
        {
            name: 'Ajustar Cashback',
            link: 'ajustar-cashback',
            icon: 'receipt_long' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.CustodiaDev],
        },
        {
            name: 'Gerenciar Cobrança',
            link: 'bloqueio-cobranca',
            icon: 'manage_accounts' as IconName,
            state: 'noSelectedItemMenu',
            allowedRoles: [Role.SysAdmin],
        },
    ];

    constructor(
        private _sidenavService: MenuService,
        public router: Router,
        private authService: AuthService
    ) {
        const roles = this.authService.getRolesArray();
        // Filtra apenas pages que têm roles restritivas (ex: CustodiaDev)
        // Pages com SysAdmin continuam visíveis pra todos (comportamento original)
        // this.pages = this.pages.filter(
        //     (page) =>
        //         page.allowedRoles.includes(Role.SysAdmin) ||
        //         roles.some((r) => page.allowedRoles.includes(r as Role))
        // );

        if (!roles.includes(Role.CustodiaDev)) {
            this.pages = this.pages.filter(
                (page) =>
                    page.link !== 'feature-parameters' &&
                    page.link !== 'disparar-cobranca' &&
                    page.link !== 'reenvio-relatorio-corrigido'
            );
        }

        this.checkRouteAndSelectItemMenu();
        this.sideNavState = true;
        this.linkText = true;
        this._sidenavService.sideNavState$.next(this.sideNavState);
    }

    onSinenavToggle() {
        this.sideNavState = !this.sideNavState;

        setTimeout(() => {
            this.linkText = this.sideNavState;
        }, 200);
        this._sidenavService.sideNavState$.next(this.sideNavState);
    }

    goTo(link: string) {
        this.router.navigateByUrl(link);
    }

    checkRouteAndSelectItemMenu() {
        this.router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            map((event) => {
                this.pages.map((itemMenu, index) => {
                    if (event.url === '/' + itemMenu.link) {
                        this.pages[index].state = 'selectedItemMenu';
                    } else if (event.url.split('/')[1] === itemMenu.link) {
                        this.pages[index].state = 'selectedItemMenu';
                    } else {
                        this.pages[index].state = 'noSelectedItemMenu';
                    }
                });
            })
        );
    }
}
